export const contactsData = {
    github: 'https://github.com/jean-joooo',
    linkedIn: 'https://www.linkedin.com/in/jeanjosephagostini/',
    devUsername: "jean-joooo",
}
